export const breakpoint = "800px";
export const S3Key = "https://idylworld-static.sgp1.digitaloceanspaces.com/";

export const brightBlue = "#00A3FF";
